export const getSlugFromData = (data: {
  slug: {
    _allSlugLocales: {
      locale: string;
      value: string;
    }[];
  };
}) => {
  const locales = data.slug._allSlugLocales;
  return "/" + (locales.find((locale) => locale.locale === "fi")?.value || "");
};
